import { Box, Typography } from '@mui/material';
import { AssignmentEditor } from '../components/AssignmentEditor';

export function AssignmentPage() {
  return (
    <Box>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>授权分配</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        将节点分配给用户或部门。分配后，用户登录客户端即可看到对应节点。
      </Typography>
      <AssignmentEditor />
    </Box>
  );
}
